import { render } from "./ImportExcelDeleteRecords.vue?vue&type=template&id=480416aa"
import script from "./ImportExcelDeleteRecords.vue?vue&type=script&lang=js"
export * from "./ImportExcelDeleteRecords.vue?vue&type=script&lang=js"
script.render = render

export default script